namespace $ {
	/** Explicit initial publication only. Existing editable pages are never replaced. */
	export class $shm_hitalama_guide_seed extends $mol_object {
		static pages(): Record<string, $shm_hitalama_guide_document_data> { return this.$.$shm_hitalama_guide_content.pages() }
		static body_upgrade( id: string, body: string ) {
			if(id==='start')return body.replace('В каждом разделе значок «?» рядом с названием открывает краткое руководство вместо выбранного объекта.','Значок «?» рядом с названием открывает руководство. В разделах со списком объектов оно показывается вместо выбранного объекта; в команде, настройках, личном кабинете и бенчмарке — справа от рабочего экрана.')
			if(id==='knowledge-edit')return body.replace('Можно изменить название, Markdown-текст и ссылки снизу. Для каждой ссылки укажите ID существующей страницы и подпись через |, по одной ссылке на строку.','Можно изменить название, группу и Markdown-текст. Ссылки добавляйте прямо в Markdown: [Название](maps.md), где maps — ID страницы. Их можно размещать в любом месте текста.').replace('«Добавить страницу»','«Добавить»')
			return body
		}
		@ $mol_action
		static apply( catalog: $shm_hitalama_guide_catalog ) {
			this.groups_apply( catalog )
			for( const [ id, page ] of Object.entries( this.pages() ) ) if( !catalog.page( id ) ) $mol_wire_sync( catalog ).create( this.pages_cached( id ), id, JSON.stringify({ ...page, parent: this.parents()[id] }) )
			for( const section of [ 'maps', 'applications', 'projects', 'skills', 'knowledge', 'team', 'settings', 'profile', 'benchmark' ] ) if( !catalog.Sections()?.key( section )?.val() ) catalog.Sections( null )!.key( section, null )!.val( section )
		}
		static groups(): [string,string,string][] { return [
			['folder-start','Начало работы',''], ['folder-maps','Карты',''],
			['folder-interface','Интерфейс',''],
			['folder-map-data','Виджеты и данные','folder-maps'], ['folder-map-sharing','Совместная работа','folder-maps'],
			['folder-apps','Приложения',''], ['folder-projects','Проекты и агент',''], ['folder-skills','Скиллы','folder-projects'],
			['folder-knowledge','База знаний',''], ['folder-account','Аккаунт и настройки',''], ['folder-measurements','Измерения',''],
			['folder-map-code','Код и автоматизация','folder-maps'], ['folder-map-recipes','Рецепты','folder-maps'],
		] }
		static parents(): Record<string,string> { return Object.fromEntries(Object.entries(this.$.$shm_hitalama_guide_content.pages()).map(([id,page])=>[id,page.parent])) }
		static groups_apply( catalog: $shm_hitalama_guide_catalog ) {
			for( const [id,title,parent] of this.groups() ) if( !catalog.group(id) ) $mol_wire_sync(catalog).group_create(this.pages_cached('group:'+id),id,title,parent)
		}
		/** Explicit, conflict-checked upgrade. Preserve authored body, links and custom groups. */
		@ $mol_action
		static organize( catalog: $shm_hitalama_guide_catalog ) {
			this.groups_apply(catalog)
			for( const id of catalog.ids() ) {
				const request = $mol_wire_sync(this).organization_request([catalog.link().str,id])
				if( request ) $mol_wire_sync(catalog.page(id)!).write(request.snapshot,request.expected)
			}
		}
		@ $mol_mem_key
		static organization_request( [catalog_id,id]: readonly string[] ) {
			const catalog = this.$.$shm_hitalama_guide_catalog.current()!
			if( catalog.link().str !== catalog_id ) throw new Error('Каталог руководства изменился.')
			const page = catalog.page(id)!, data = page.read(), next = { ...data, body: this.body_upgrade(id,this.$.$shm_hitalama_guide_markdown.text(data)), links: [], parent: data.parent || this.parents()[id] || '' }
			return JSON.stringify(data) === JSON.stringify(next) ? null : { snapshot: JSON.stringify(next), expected: page.File()!.remote()!.link().str }
		}
		@ $mol_mem_key
		static pages_cached( id: string ) { return { id } }
	}
}
